import React, { Component} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Switch, FormControlLabel } from '@material-ui/core';
import * as XLSX from "xlsx";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import LinearProgress from "@material-ui/core/LinearProgress";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { IconButton, Typography } from "@material-ui/core";

import { getCourseVotes } from "../firebaseApi";

const styles = (theme) => ({});

/*
 * DATA FORMAT:
 *
 * data = [
 *   {
 *     categories: [
 *       'category1',
 *        ...
 *     ],
 *     sessions: [
 *       #, // Number of polls for session 1
 *        ...
 *     ]
 *   },
 *   {
 *     studentFirstName: 'studentFirstName',
 *     studentLastName: 'studentLastName',
 *     studentID: 'studentID',
 *     identifer: 'identifier',
 *     iClicker: 'iClicker',
 *     studentCategories: [
 *       'optionA' // Option chosen for category1
 *        ...
 *     ],
 *     studentVotes: [
 *       'A',
 *        ...
 *     ],
 *   },
 *    ...
 * ]
 */

class InstructorCourseExport extends Component {
  state = {
    exporting: false,
    showLoadingIndicator: false,
    correctOnly:false,
    showExportInfoDialog: false,
    anonVotes:false,
  };

  exportVotes() {
    this.setState({ exporting: true, showLoadingIndicator: true });

    getCourseVotes(this.props.course.courseID)
      .then((data) => {
        //console.log(data);
        let categNum = 0;
        let csvData = [];
        // Populate first row of csv
        csvData.push([]);
        csvData[0].push("Email");
        csvData[0].push("Last Name");
        csvData[0].push("First Name");
        // csvData[0].push("Student Identifier");
        this.props.course.iClickerEn && csvData[0].push("iClicker ID");
        data[0].categories.forEach((category) => {
          categNum++;
          csvData[0].push(category);
        });
        let sessionCount = 1;
        data[0].sessions.forEach((numPolls) => {
          if (numPolls !== 0) {
            csvData[0].push("Session " + sessionCount);
          }

          for (let i = 1; i < numPolls; i++) {
            csvData[0].push(undefined);
          }

          sessionCount++;
        });

        // Populate second row of csv
        csvData.push([]);
        // Blank for student info
        for (let i = 0; i < 3 + data[0].categories.length; i++) {
          csvData[1].push(undefined);
        }
        // Poll# for each session
        data[0].sessions.forEach((numPolls) => {
          for (let i = 1; i <= numPolls; i++) {
            csvData[1].push("Poll " + i);
          }

          sessionCount++;
        });

        // Populate each student row of csv
        for (let i = 1; i < data.length - 5; i++) {
          let student = data[i];
          csvData.push([]);

          // Student name and ID
          csvData[i + 1].push(student.studentID);
          csvData[i + 1].push(student.studentLastName);
          csvData[i + 1].push(student.studentFirstName);
          // csvData[i + 1].push(student.identifier);
          this.props.course.iClickerEn && csvData[i + 1].push(student.iClicker);

          // Student categories
          student.studentCategories.forEach((category) => {
            if (category === undefined) {
              csvData[i + 1].push("Unknown");
            } else {
              csvData[i + 1].push(category);
            }
          });

          // Student votes
          let j = 0;
          student.studentVotes.forEach((vote) => {
            if (vote === undefined) {
              csvData[i + 1].push(undefined);
            } else {
              if(this.state.correctOnly){
                if(vote.includes(data[0].answers[j]) || data[0].answers[j] === undefined){
                  csvData[i + 1].push(vote);
                }else{
                  csvData[i + 1].push(undefined);
                }

              }
              else if(vote.includes("X")){
                csvData[i+1].push("X")
              }else{
                csvData[i + 1].push(vote);
              }
            }
            j++;
          });
        }
        if(this.state.anonVotes){
          for (let i = data.length - 5; i < data.length; i++) {
            let anon = data[i];
            csvData.push([]);
            csvData[i + 1].push("Anonymous Votes " + anon.studentID);
            for (let j = 0; j < categNum + 2; j++) {
              csvData[i + 1].push(undefined);
            }
            anon.studentVotes.forEach((vote) => {
              csvData[i + 1].push(vote);
            });
          }
        }
        // Generate .csv file
        let wb = XLSX.utils.book_new();
        let ws = XLSX.utils.aoa_to_sheet(csvData);
        let name = this.props.course.courseName.slice(0, 25) + " Votes";
        XLSX.utils.book_append_sheet(wb, ws, name);
        XLSX.writeFile(wb, name + ".csv");

        this.setState({ exporting: false, showLoadingIndicator: false });
        this.props.openCtl(false);
      })
      .catch((err) => {
        // console.log(err);
        this.setState({ exporting: false, showLoadingIndicator: false });
        this.props.openCtl(false);
      });
  }

  render() {
    let mobile = this.props.width === "sm" || this.props.width === "xs";
    const { exporting, showLoadingIndicator } = this.state;

    return (
      <>
        <Dialog
          fullScreen={mobile}
          fullWidth
          maxWidth="sm"
          open={this.props.open}
          onClose={() => {
            this.props.openCtl(false);
          }}
        >
          <DialogTitle>{"Export " + this.props.course.courseName}</DialogTitle>

          <DialogContent>
            <DialogContentText>
              Export the votes for the course {this.props.course.courseName} as
              a .csv file?
              <IconButton
                variant="outlined"
                color="primary"
                style={{ marginBottom: "2px" }}
                onClick={() => {
                  this.setState({ showExportInfoDialog: true });
                }}
              >
                <InfoOutlinedIcon />
              </IconButton>
            </DialogContentText>
            <FormControlLabel
              control={
              <Switch
                checked={this.state.correctOnly}
                onChange={(event)=>{this.props.correctSet(event.target.checked);this.setState({correctOnly:event.target.checked});}}
                name="toggleSwitch"
                color="primary"
              />
              } 
            label={this.state.correctOnly ? "Correct Votes Only" : "All Votes"}
            />
          <FormControlLabel
            control={
          <Switch
            checked={this.state.anonVotes}
            onChange={(event)=>{this.props.anonSet(event.target.checked);this.setState({anonVotes:event.target.checked});}}
            name="toggleSwitch"
            color="primary"
          />
        } 
        label={this.state.anonVotes ? "Include Anonymous Votes" : "No Anonymous Votes"}
    />
          </DialogContent>

          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                this.props.openCtl(false);
              }}
            >
              Cancel
            </Button>

            <Button
              color="primary"
              onClick={() => {
                this.setState({ showLoadingIndicator: true }, () => {
                  this.exportVotes();
                });
              }}
              disabled={exporting}
            >
              Export
            </Button>
            <Button
              color="primary"
              onClick={() => {
                this.setState({ showLoadingIndicator: true }, () => {
                  this.props.openSelect(false);
                });
              }}
              disabled={exporting}
            >
              Advanced Export
            </Button>
          </DialogActions>
          {showLoadingIndicator && <LinearProgress />}
        </Dialog>

        <Dialog
          open={this.state.showExportInfoDialog}
          onClose={() => this.setState({ showExportInfoDialog: false })}
        >
          <DialogContent>
            <Typography>
              The downloaded files will contain the student votes for each poll.
              The following conventions are used: * A/B/C/D/E: regular vote *X:
              vote on anonymous poll * GA/GB/GC/GD/GE: vote outside of geofence
              without override.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({ showExportInfoDialog: false });
              }}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(InstructorCourseExport))
  )
);
